import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { FormControl, FormGroup } from '@angular/forms';
import { IInvoice } from 'app/models/invoices/invoice';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IInvoiceSearch } from 'app/models/invoices/invoice-search';
import { ISelectListItem } from 'app/models/common/select.list.item';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  }),
  withCredentials: true
};

const httpOptionsForFiles = {
  withCredentials: true
};

@Injectable({
  providedIn: 'root'
})

export class InvoiceService {
  
  invoiceTypes: string[] = ['Testing', 'Treatment', 'Wildfire'];
  search: IInvoiceSearch = {
    id: '',
    labName: '',
    pca: '',
    index: '',
    voucherType: '',
    voucherIdentifier: '',
    pastDue: false,
    invoiceType: ''
  };

  searchForm = new FormGroup({
    id: new FormControl(),
    invoiceNumber: new FormControl(''),
    labName: new FormControl(''),
    voucherIdentifier: new FormControl('') ,
    voucherType: new FormControl(''),   
    pca: new FormControl(''),    
    index: new FormControl(''),   
    agencyObjectCode: new FormControl(''),  
    mailCode: new FormControl(''),  
    pastDue: new FormControl(false), 
    paymentStatus: new FormControl(''),
    invoiceType: new FormControl('')
  });

  haveSearchResults = false;
  searchResultsCount = 0;
  searchResults: IInvoice[] = [];

  constructor(private toastr: ToastrService, private http?: HttpClient) { }

  deleteInvoiceById(id: number): Observable<any> {
    return this.http.get(environment.privateApi + 'Invoice/DeleteInvoice/' + id, httpOptions);
  }

  getInvoiceById(invoiceId: number): Observable<IInvoice> {
    return this.http.get<IInvoice>(environment.privateApi + 'Invoice/GetInvoice/' + invoiceId, { withCredentials: true });
  }

  getMostRecentNitrateTestDate(voucherIdentifier: string): Observable<any> {
    return this.http.get(environment.privateApi + 'Invoice/GetMostRecentNitrateTestDate/' + voucherIdentifier, { responseType: 'text' as 'json' });
  }

  getVoucherIds(): Observable<any> {
    return this.http.get<ISelectListItem>(environment.privateApi + 'Voucher/GetVoucherIds', { withCredentials: true });
  }

  saveVoucherInvoice(invoice: IInvoice): Observable<any> {
    return this.http.post(environment.privateApi + 'Invoice/SaveVoucherInvoice', invoice, httpOptions);
  }

  Search(search: IInvoiceSearch): Observable<any> {
    return this.http.post(environment.privateApi + 'Invoice/Search', search, httpOptions);
  }
}